import { useRef, useEffect, useCallback } from 'react';
import { Box, Typography, Button, TextField, Stack } from '@mui/material';
import Input from './Input';
import { Refresh } from '@mui/icons-material';

function SimpleCaptcha({ onGenerate, value, onChange }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = useCallback(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Set background
    ctx.fillStyle = '#f0f0f0';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Generate random text (5-6 characters)
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
    let captchaString = '';
    const length = Math.floor(Math.random() * 2) + 5; // 5-6 characters
    
    for (let i = 0; i < length; i++) {
      captchaString += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    
    // Send captcha text to parent component
    onGenerate(captchaString);
    
    // Draw distorted text
    const textColors = ['#333333', '#4a4a4a', '#666666', '#808080', '#0c4da2'];
    const textFonts = ['Arial', 'Verdana', 'Times New Roman', 'Courier', 'Georgia'];
    
    // Add noise (dots)
    for (let i = 0; i < 80; i++) {
      ctx.fillStyle = `rgba(${Math.random() * 200}, ${Math.random() * 200}, ${Math.random() * 200}, 0.3)`;
      ctx.beginPath();
      ctx.arc(
        Math.random() * canvas.width, 
        Math.random() * canvas.height, 
        Math.random() * 1.5, 
        0, 
        Math.PI * 2
      );
      ctx.fill();
    }
    
    // Draw random lines
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.strokeStyle = `rgba(${Math.random() * 200}, ${Math.random() * 200}, ${Math.random() * 200}, 0.5)`;
      ctx.lineWidth = Math.random() * 1.2;
      ctx.stroke();
    }
    
    // Draw characters with various effects
    for (let i = 0; i < captchaString.length; i++) {
      // Randomize character appearance
      const x = 15 + (i * 22) + Math.random() * 10 - 4;
      const y = canvas.height / 2 + Math.random() * 24 - 5;
      const fontSize = 26 + Math.random() * 8;
      const rotation = (Math.random() - 0.5) * 0.4; // Slight rotation
      
      // Select random font and color
      ctx.fillStyle = textColors[Math.floor(Math.random() * textColors.length)];
      ctx.font = `bold ${fontSize}px ${textFonts[Math.floor(Math.random() * textFonts.length)]}`;
      
      // Apply transformation
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rotation);
      
      // Draw character
      ctx.fillText(captchaString[i], 0, 0);
      
      // Restore transformation
      ctx.restore();
    }
  }, [onGenerate]);

  return (
    <Stack direction="row" spacing={2} alignItems="center">
       
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <canvas 
            ref={canvasRef} 
            width="200" 
            height="70" 
            style={{ border: '1px solid #ccc', borderRadius: '4px' }}
          />
          <Button 
            variant="outlined" 
            size="small" 
            onClick={generateCaptcha}
            sx={{ minWidth: 'auto', padding: '4px 8px', height: 'fit-content' }}
          >
            <Refresh />
          </Button>
        </Box>
        <Input
          label="Enter text from image"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          size="small"
          fullWidth
          required
          margin="dense"
        />
       
    </Stack>
  );
}

export default SimpleCaptcha; 